import type { DepartmentItem, DepartmentOption } from './type';

const mapDepartmentToOption = (dept: DepartmentItem): DepartmentOption => ({
  ...dept,
  value: dept.id,
  label: dept.name,
});

export const mapDepartmentsToOptions = (
  departments: readonly DepartmentItem[],
): readonly DepartmentOption[] => departments.map(mapDepartmentToOption);
